import { render } from "./yingyangcan.vue?vue&type=template&id=23eddea8&scoped=true"
import script from "./yingyangcan.vue?vue&type=script&lang=js"
export * from "./yingyangcan.vue?vue&type=script&lang=js"

import "./yingyangcan.vue?vue&type=style&index=0&id=23eddea8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-23eddea8"

export default script